import { Pipe, PipeTransform } from '@angular/core';
import has from 'lodash-es/has';

@Pipe({
    name: 'isMeMedia',
    standalone: true
})
export class IsMeMediaPipe implements PipeTransform {

    transform(value: unknown, ...args: unknown[]): unknown {
        if (!Array.isArray(value) || value.length === 0) {
            return false;
        }

        return has(value[0], 'type');
    }
}
